var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6147 12.7213C18.6147 13.2329 18.4115 13.7236 18.0498 14.0853C17.688 14.4471 17.1974 14.6503 16.6858 14.6503H5.11201L1.25409 18.5082V3.07651C1.25409 2.56492 1.45732 2.07428 1.81907 1.71253C2.18082 1.35078 2.67146 1.14755 3.18305 1.14755H16.6858C17.1974 1.14755 17.688 1.35078 18.0498 1.71253C18.4115 2.07428 18.6147 2.56492 18.6147 3.07651V12.7213Z",
    stroke: "#C5C5D1",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.ef36f79693990ff17ecf42cd018fcb4e.svg";
export { ForwardRef as ReactComponent };